import { createContext, useContext } from 'react';

export const GoogleMapsContext = createContext({ isLoaded: false });

export const useGoogleMaps = () => useContext(GoogleMapsContext);
